// extracted by mini-css-extract-plugin
export default {"pagination-item":"PaginationItem_pagination-item__UuiBZ","pagination-item__btn--active":"PaginationItem_pagination-item__btn--active__e+DzH"};